module.exports = __webpack_public_path__ + "static/bamidele-c60a6cf5ffdcbf5baebbd0ec8c618055.jpg";